import moment from 'moment';
import { EBAY_REASON_RETURN_TROUBLE, STATUS_ITEM_MANAGEMENT } from './constants';
import axios from 'axios';
import momentUS from 'moment-timezone';

export const toCamelCase = (str) => {
  // Split the string into words
  let words = str.split(/[\s-_]+/);

  // Convert the first word to lowercase
  let camelCaseStr = words[0].toLowerCase();

  // Process each subsequent word
  for (let i = 1; i < words.length; i++) {
    let word = words[i];
    camelCaseStr += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  return camelCaseStr;
};

export const getLinkCancelationNavigate = (returnId: string) =>
  `https://www.ebay.com/rtn/Return/ReturnsDetail?returnId=${returnId}`;

export const getLinkUserEbayNavigate = (userEbayId: string, type: 'str' | 'usr') =>
  `https://www.ebay.com/${type}/${userEbayId}`;

export const getLinkItemEbayNavigate = (itemId: string) => `https://www.ebay.com/itm/${itemId}`;

//YYYY/MM/DD
export const formatDate = (time: Date | string) => (time ? moment(time).format('YYYY/MM/DD') : '');

export const AmericaTimezone = 'America/Los_Angeles';

export const formatDateUS = (time: Date | string) =>
  time ? momentUS(time).tz(AmericaTimezone).format('YYYY/MM/DD') : '';

//YYYY年MM月DD日
export const formatDateJP = (isoString: string) => {
  const formattedDate = moment(isoString).format('YYYY年MM月DD日');
  return formattedDate;
};
export const formatCurrency = (number: number, minimumFractionDigits = 0, maximumFractionDigits = 2) =>
  new Intl.NumberFormat('en-US', { minimumFractionDigits, maximumFractionDigits }).format(number || 0);

export const countDecimalPlaces = (num: number) => {
  if (!num) return 0;
  const numStr = num.toString();
  const decimalIndex = numStr.indexOf('.');
  if (decimalIndex === -1) {
    return 0;
  }
  return numStr.length - decimalIndex - 1;
};

export const handleViewStatusItem = (status: string): string => {
  switch (status) {
    case STATUS_ITEM_MANAGEMENT.NOT_DELIVERED:
    case STATUS_ITEM_MANAGEMENT.NOT_SHIPPED:
      return 'バイヤー発送前';
    case STATUS_ITEM_MANAGEMENT.IN_TRANSIT:
      return '返送中';
    case STATUS_ITEM_MANAGEMENT.DELIVERED:
    case STATUS_ITEM_MANAGEMENT.WAITING_STORAGE:
    case STATUS_ITEM_MANAGEMENT.WAITING_UPLOAD_IMAGE_VIDEO:
      return '到着済';
    case STATUS_ITEM_MANAGEMENT.IN_STORAGE:
      return '保管中';
    case STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING:
    case STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING_DONE:
      return '発送手配中';
    case STATUS_ITEM_MANAGEMENT.SHIPPED_BACK:
      // TODO: phase 2 shipback cần check lại
      return '発送';
    case STATUS_ITEM_MANAGEMENT.DISPOSED:
      return '廃棄済';
    case STATUS_ITEM_MANAGEMENT.CANCELED:
      return 'キャンセル済';
    case STATUS_ITEM_MANAGEMENT.NEW_DISPOSAL_REQUEST:
      return '廃棄依頼';
    case STATUS_ITEM_MANAGEMENT.SHIPPED_TO_BUYER:
      return 'バイヤーへ発送済';
    case STATUS_ITEM_MANAGEMENT.PRICE_INPUTED:
      return '廃棄処理待ち';
    default:
      return '';
  }
};

export const fetchFileContent = async (url) => {
  try {
    const response = await axios.get(url, {
      responseType: 'arraybuffer', // Important for handling binary data
    });
    return {
      filename: url.substring(url.lastIndexOf('/') + 1), // Extract filename from URL
      content: response.data,
    };
  } catch (error) {
    console.error('Error fetching file:', error);
    return null;
  }
};

export const getLinkOrderEbayNavigate = (orderId: string) => `https://www.ebay.com/mesh/ord/details?orderid=${orderId}`;

export const sentToSlack = async (msg: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/sent-to-slack`,
    {
      message: msg,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};
const EBAY_IMAGE_SIZES = [64, 140, 225, 300, 400, 500, 800, 1600];

export const resizeImageItemEbay = (urlImage: string, size: number = 300): string => {
  if (!urlImage) return urlImage;

  const validSize = EBAY_IMAGE_SIZES.find((s) => s >= size) ?? EBAY_IMAGE_SIZES[EBAY_IMAGE_SIZES.length - 1];

  return urlImage.replace(/s-l\d+\.jpg$/, `s-l${validSize}.jpg`);
};

export const convertFullwidthToHalfwidth = (str: string) =>
  str.replace(/[\uff01-\uff5e]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0)).replace(/\u3000/g, ' ');

export const calculateVolumnWeight = (height: number, width: number, length: number) => {
  return (height * width * length) / 5000;
};

export const mappingReason = (reason: string) => {
  const EBAY_RETURN_REASONS = {
    [EBAY_REASON_RETURN_TROUBLE.ARRIVED_DAMAGED]: 'Arrived damaged',
    [EBAY_REASON_RETURN_TROUBLE.DEFECTIVE_ITEM]: 'Doesn’t work or defective',
    [EBAY_REASON_RETURN_TROUBLE.DIFFERENT_FROM_LISTING]: 'Doesn’t match description or photos',
    [EBAY_REASON_RETURN_TROUBLE.FAKE_OR_COUNTERFEIT]: 'Doesn’t seem authentic',
    [EBAY_REASON_RETURN_TROUBLE.FOUND_BETTER_PRICE]: 'Found better price',
    [EBAY_REASON_RETURN_TROUBLE.MISSING_PARTS]: 'Missing parts or accessories',
    [EBAY_REASON_RETURN_TROUBLE.NO_LONGER_NEED_ITEM]: 'Changed mind',
    [EBAY_REASON_RETURN_TROUBLE.NOT_AS_DESCRIBED]: 'Doesn’t match description or photos',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_ACCIDENTALLY]: 'Ordered by mistake',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_DIFFERENT_ITEM]: 'Wrong item sent',
    [EBAY_REASON_RETURN_TROUBLE.ORDERED_WRONG_ITEM]: 'Didn’t like item',
    [EBAY_REASON_RETURN_TROUBLE.WRONG_SIZE]: 'Doesn’t fit',
  };

  return EBAY_RETURN_REASONS[reason] || reason;
};

export const containsInvalidCharacters = (address: string): boolean => {
  const invalidCharRegex = /[^a-zA-Z0-9\s+,-.;:()_"'\[\]\\~]/;
  return invalidCharRegex.test(address);
};

export const normalize = (v?: any) => (typeof v === 'string' ? v.trim() : v);
export type LabelGetter<T> = (item: T) => string;

type Options = {
  locale?: string;
  sensitivity?: Intl.CollatorOptions['sensitivity'];
  numeric?: boolean;
  normalize?: boolean;
  noIndexPosition?: 'first' | 'last';
};

function splitName(s: string) {
  const m = s.match(/\((\d+)\)(?=[^()]*$)/);
  const index = m ? parseInt(m[1], 10) : null;
  const base = s.replace(/\(\d+\)(?=[^()]*$)/, '').trim();
  return { base, index };
}

// Overloads
export function sortByParenIndex<T extends { originName?: string; name?: string }>(
  items: ReadonlyArray<T>,
  getLabel?: LabelGetter<T>,
  opts?: Options,
): T[];
export function sortByParenIndex<T>(items: ReadonlyArray<T>, getLabel: LabelGetter<T>, opts?: Options): T[];

// Impl
export function sortByParenIndex<T>(items: ReadonlyArray<T>, getLabel?: LabelGetter<T>, opts: Options = {}): T[] {
  const { locale = 'vi', sensitivity = 'base', numeric = true, normalize = true, noIndexPosition = 'last' } = opts;

  const collator = new Intl.Collator(locale, { numeric, sensitivity });
  const norm = (s: string) => (normalize ? s.toString().normalize('NFKC') : s.toString());

  const defaultGetter = (x: any) => (x?.originName ?? x?.name ?? '') as string;
  const pick = (item: T) => norm((getLabel ?? defaultGetter)(item));

  return [...items].sort((a, b) => {
    const sa = pick(a);
    const sb = pick(b);
    const A = splitName(sa);
    const B = splitName(sb);

    const byBase = collator.compare(A.base, B.base);
    if (byBase !== 0) return byBase;

    const aHas = A.index !== null;
    const bHas = B.index !== null;
    if (aHas && bHas) return (A.index as number) - (B.index as number);
    if (aHas !== bHas) return noIndexPosition === 'first' ? (aHas ? 1 : -1) : aHas ? -1 : 1;

    return collator.compare(sa, sb);
  });
}

export function getFileNameFromUrl(input?: string): string {
  if (!input) return '';
  const s = String(input).trim();
  try {
    const url = new URL(s, (typeof window !== 'undefined' && window.location?.origin) || 'http://localhost');
    const pathLast = url.pathname.split('/').filter(Boolean).pop();
    if (pathLast) return decodeURIComponent(pathLast);

    const candKeys = ['filename', 'file', 'name', 'download', 'response-content-disposition'];
    for (const k of candKeys) {
      const v = url.searchParams.get(k);
      if (!v) continue;
      if (k === 'response-content-disposition') {
        const m = v.match(/filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i);
        if (m?.[2]) return decodeURIComponent(m[2]);
      } else {
        const last = v.split('/').filter(Boolean).pop() || v;
        return decodeURIComponent(last);
      }
    }
  } catch {}

  const noHash = s.split('#')[0];
  const noQuery = noHash.split('?')[0];
  const last = noQuery.split(/[\\/]/).filter(Boolean).pop() || '';
  try {
    return decodeURIComponent(last);
  } catch {
    return last;
  }
}
